import { StyleSheet, View } from 'react-native';

import colors from 'config/colors';
import { OrderDetails } from 'modules/GridView/components/OrderDetails';
import { GridViewContextProvider } from 'modules/GridView/contexts/GridViewContext';

import { List } from './List';

const GridViewSceneComponent = () => {
  return (
    <View style={{ flexDirection: 'row', height: '100%' }}>
      <View
        style={{
          width: '100%',
          minWidth: 330,
          borderRightWidth: 0,
          backgroundColor: colors.darkBlue,
        }}
      >
        <List />
      </View>
      <OrderDetails />
    </View>
  );
};

export const GridViewScene = () => {
  return (
    <GridViewContextProvider>
      <View style={styles.container}>
        <GridViewSceneComponent />
      </View>
    </GridViewContextProvider>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.lightBlue2,
    flex: 1,
    height: '100%',
    width: '100%',
  },
});
